import { useSelector } from "react-redux"
import { Badge, Box } from "@mui/material"
import { currencyFormat } from "src/app/utils"
import { DEFAULT_PRODUCT_IMAGE } from "src/app/constants"

export default function HawaiiGet() {
  const cart = useSelector((state) => state.checkout.cart)

  return (
    <Box sx={styles.itemContainer}>
      <Badge
        badgeContent={1}
        sx={{
          "& .MuiBadge-badge": {
            color: "white",
            backgroundColor: "grey",
          },
        }}
      >
        <Box sx={styles.thumbnailContainer}>
          <img src={DEFAULT_PRODUCT_IMAGE} height="50px" width="auto" />
        </Box>
      </Badge>
      <Box sx={styles.itemTitleContainer}>
        <span style={styles.itemTitle}>General Excise Tax</span>
        <span style={styles.itemVariantTitle}>General Excise Tax</span>
      </Box>
      <span style={styles.amount}>
        {currencyFormat(cart.cost?.totalAmount?.amount * 0.04712)}
      </span>
    </Box>
  )
}

const styles = {
  itemContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 2,
  },
  thumbnailContainer: {
    backgroundColor: "white",
    border: "1px solid #eee",
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 64,
    height: 64,
    textAlign: "center",
  },
  itemTitleContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginX: 2,
  },
  itemTitle: {
    fontSize: "14px",
    fontWeight: 500,
  },
  itemVariantTitle: {
    color: "#6e6e6e",
    fontSize: "12px",
    fontWeight: 400,
    marginTop: 4,
  },
  amount: {
    fontSize: "14px",
    fontWeight: 500,
  },
}
